export const FETCH_OFFERS_REQUEST = 'agentsPwa/Offers/FETCH_OFFERS_REQUEST';
export const SHOULD_FETCH_OFFERS = 'agentsPwa/Offers/SHOULD_FETCH_OFFERS';
export const OFFER_HOUSE_FETCH_SUCCESS =
  'agentsPwa/Offers/OFFER_HOUSE_FETCH_SUCCESS';
export const OFFER_USER_FETCH_SUCCESS =
  'agentsPwa/Offers/OFFER_USER_FETCH_SUCCESS';
export const FETCH_RENT_FLOW_OFFERS = 'agentsPwa/Offers/FETCH_RENT_FLOW_OFFERS';
